import { cn } from '@/lib/utils';

/**
 * Lambang resmi TIRTA SMART (logo desa). Dirender di dalam lencana bulat putih
 * agar tetap terbaca pada permukaan terang maupun gelap.
 */
export function BrandMark({
  className,
  alt = 'TIRTA SMART',
}: {
  className?: string;
  alt?: string;
}) {
  return (
    <img
      src="/logo-mark.png"
      alt={alt}
      width={512}
      height={512}
      decoding="async"
      className={cn(
        'block shrink-0 rounded-full bg-white object-contain ring-1 ring-black/5 dark:ring-white/15',
        className,
      )}
    />
  );
}
